// Smooth desktop wheels without taking over touch, keyboard or nested scrollers.
export function initSmoothScroll() {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(hover: hover) and (pointer: fine)');
    let frame = 0;
    let target = window.scrollY;
    let lastTime = 0;
    const stop = () => {
        cancelAnimationFrame(frame);
        frame = 0;
        target = window.scrollY;
    };
    const tick = (time) => {
        const elapsed = Math.min(64, time - lastTime);
        lastTime = time;
        target = Math.min(target, Math.max(0, document.documentElement.scrollHeight - window.innerHeight));
        const distance = target - window.scrollY;
        window.scrollTo({ top: Math.abs(distance) < 0.8 ? target : window.scrollY + Math.sign(distance) * Math.max(1, Math.abs(distance) * (1 - Math.exp(-elapsed / 90))), behavior: 'instant' });
        if (Math.abs(target - window.scrollY) > 0.8) frame = requestAnimationFrame(tick);
        else frame = 0;
    };
    window.addEventListener('wheel', (event) => {
        if (document.documentElement.classList.contains('demo-popup-open') || event.defaultPrevented || reduced.matches || !desktop.matches || event.ctrlKey || event.metaKey || Math.abs(event.deltaX) >= Math.abs(event.deltaY)) {
            stop();
            return;
        }
        const direction = Math.sign(event.deltaY);
        for (let node = event.target; node instanceof Element && node !== document.body; node = node.parentElement) {
            if (node.matches('input, textarea, select, [contenteditable="true"], [role="dialog"]')) { stop(); return; }
            const style = getComputedStyle(node);
            if (/(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight &&
                (direction < 0 ? node.scrollTop > 0 : node.scrollTop + node.clientHeight < node.scrollHeight - 1)) { stop(); return; }
        }
        if (!event.cancelable) return;
        event.preventDefault();
        if (!frame) target = window.scrollY;
        target += event.deltaY * (event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? window.innerHeight : 1);
        target = Math.max(0, Math.min(target, document.documentElement.scrollHeight - window.innerHeight));
        if (!frame) { lastTime = performance.now(); frame = requestAnimationFrame(tick); }
    }, { passive: false });
    ['touchstart', 'pointerdown', 'keydown'].forEach((type) => window.addEventListener(type, stop, { passive: true }));
    reduced.addEventListener('change', stop);
    window.addEventListener('resize', stop);
    return { stop, isActive: () => Boolean(frame) };
}
